import { generatePath } from 'react-router-dom'
import { IResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { takeEvery } from 'redux-saga/effects'
import { ROUTES } from '../../constants/routes'
import { sagaNavigate } from '../navigationHelper'
import { START_FAILURE } from './actions'

export function* clientIntakeRedirect() {
  yield takeEvery(START_FAILURE, function* (action: IResponse & Action) {
    if (action.error.code === 'PERMANENT_REDIRECT') {
      const errorData = action.error.data as { salesforceId: string }
      sagaNavigate(
        generatePath(ROUTES.CLIENT_INTAKE, {
          salesforceId: errorData.salesforceId,
        }),
      )
    }
    yield
  })
}
